<template>
  <div data-private class="flex h-full">
    <PageSidebar title="Pages" :items="sidebarItems">
      <LoadingIndicator v-if="loading" message="Loading pages..." />
      <div v-else-if="error" class="p-4">
        <div class="bg-red-50 border border-red-200 rounded-md p-3">
          <p class="text-sm text-red-700">{{ error }}</p>
        </div>
      </div>
    </PageSidebar>
    <div class="flex-1 h-full overflow-auto bg-gray-100">
      <PageHost :key="`${subject}-${subjectId}`" :subject="subject" :subject-id="subjectId" />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { FEATURES } from '@/constants/features';
import { canAccessFeature } from '@/utils/access';
import PageSidebar from '../widgetcomponents/library/PageSidebar.vue';
import LoadingIndicator from '../widgetcomponents/library/LoadingIndicator.vue';
import PageHost from './PageHost.vue';

export default {
  name: 'PagesView',
  components: { PageSidebar, LoadingIndicator, PageHost },
  props: {
    subject: { type: String, default: 'overall' },
    subjectId: { type: Number, default: null },
  },
  data() {
    return { domains: [], mine: [], loading: false, error: null };
  },
  computed: {
    sidebarItems() {
      const items = [{ id: 'overall', label: 'Overall Performance', to: '/pages' }];
      this.domains.forEach((domain) => {
        items.push({
          id: `domain-${domain.id}`,
          label: domain.name,
          to: `/pages/domain/${domain.id}`,
          children: (domain.composable_metrics || [])
            .map((link) => ({ id: `metric-${link.metric_id}`, label: link.metric_name, to: `/pages/metric/${link.metric_id}` }))
            .sort((a, b) => a.label.localeCompare(b.label)),
        });
      });
      if (this.mine.length) {
        items.push({ id: 'mine-header', label: 'My Pages', header: true, canAccess: FEATURES.MODULE_AGENT });
        this.mine.forEach((page) => {
          items.push({ id: `mine-${page.id}`, label: page.title, to: `/pages/mine/${page.id}`, sensitive: true, canAccess: FEATURES.MODULE_AGENT });
        });
      }
      return items;
    },
  },
  mounted() {
    this.fetchDomains();
    this.fetchMine();
  },
  methods: {
    async fetchDomains() {
      this.loading = true;
      this.error = null;
      try {
        const { data } = await axios.get('/api/performancedomains/');
        this.domains = data;
      } catch (err) {
        console.error('Error fetching performance domains:', err);
        this.error = 'Failed to load performance domains';
      } finally {
        this.loading = false;
      }
    },
    async fetchMine() {
      if (!canAccessFeature(FEATURES.MODULE_AGENT)) return;
      const { data } = await axios.get('/api/impact_analytics/agent-pages/');
      this.mine = data.filter((page) => page.mine && !page.subject_type);
    },
  },
};
</script>
